export default "__VITE_ASSET__C65$gTlt__"